export default __webpack_public_path__ + "static/media/67t.6c78cd9c.jpg";